"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _immer = _interopRequireDefault(require("immer"));

var _antd = require("antd");

var Checkbox = function Checkbox(props) {
  var _props$value = props.value,
      value = _props$value === void 0 ? [] : _props$value,
      options = props.options,
      onChange = props.onChange;
  var checkedValue = value;

  if (!Array.isArray(value)) {
    console.warn('Checkbox value must be an array');
    checkedValue = [];
  }

  var handleChange = function handleChange(e) {
    var _e$target = e.target,
        checked = _e$target.checked,
        value = _e$target.value;
    var newValues = (0, _immer.default)(checkedValue, function (draft) {
      if (checked) {
        draft.push(value);
      } else {
        draft = draft.filter(function (v) {
          return v !== value;
        });
      }

      return draft;
    });
    onChange(newValues);
  };

  return /*#__PURE__*/_react.default.createElement("div", null, options && options.map(function (o) {
    return /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
      key: o.value,
      value: o.value,
      checked: checkedValue.includes(o.value),
      children: o.name,
      onChange: handleChange
    });
  }));
};

var _default = Checkbox;
exports.default = _default;